import { createPinia } from 'pinia';
import piniaPersist from 'pinia-plugin-persist';
// 创建 Pinia 实例
const pinia = createPinia();
// 使用持久化插件
pinia.use(piniaPersist);
export default pinia;